import React from 'react';

import { useAlert } from '../../../commons/components/alert/index.jsx';
import useQuery from '../../../commons/hooks/useQuery.js';
import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons/faPaperPlane';
import axios from 'axios';

const FormActivateMail = ({ }) => {
  const { email } = useQuery();

  const showAlert = useAlert();

  return (
    <>
      <h2>Your account is not activated</h2>
      <div className="form-group">
        <label>
          Please confirm your email and send the activate email
        </label>
        <div
          className="input-group">
          <input
            className="form-control"
            value={email}
            disabled
          />
        </div>
      </div>
      <div className="form-group text-right">
        <button
          type='button'
          className="btn btn-primary btn-block"
          onClick={async () => {
            try {

              const res = await axios.post('/api/core/shareStocks/send-reg-mail', {
                email,
              });

              if (res.status === 200) {
                showAlert('success', 'Send successfully', 2000);
              } else {
                showAlert('danger', 'Unknown error', 2000);
              }

            } catch (e) {
              if (e.response?.status === 400) {
                showAlert('danger', e.response.data, 2000);
              } else {
                showAlert('danger', e, 2000);
              }
            }
          }}
        >
          <FA
            icon={faPaperPlane}
            fixedWidth
          />
          {' '}
          Send activate email
        </button>
      </div>
    </>
  );
};

export default FormActivateMail;
